
//Types should be in const to avoid typos and duplication since it's a string and could be easily miss spelled
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const ADD_SHIPPING = 'ADD_SHIPPING';
export const SET_USER ='SET_USER';
export const SET_PRODUCT ='SET_PRODUCT';
export const SET_PROD ='SET_PROD';
export const SEND_DATA ='SEND_DATA';
export const HANDLE_DETAILS='HANDLE_DETAILS';
export const SET_NAME='SET_NAME';

